import {faM} from "@fortawesome/free-solid-svg-icons";

export default faM;
